export class CarsModel {
  stock_id?: string;
  mmcode?: string;
  variant?: string;
  series?: string;
  make?: string;
  selling_price?: string;
  year?: string;
  // mileage?: number;
  mileage?: string;
  date_created?: string;
  date_updated?: null;
  description?: string;
  condition?: string;
  colour?: string;
  province?: string;
  suburb?: string;
  extras_csv?: string;
  body_type?: string;
  finance_url?: string;
  image_count?: string;
  url1?: string;
  url2?: string;
  url3?: string;
  url4?: string;
  url5?: string;
  url6?: string;
  url7?: string;
  url8?: string;
  url9?: string;
  url10?: string;
  url11?: string;
  url12?: string;
  url13?: string;
  url14?: string;
  url15?: string;
  url16?: string;
  url17?: string;
  url18?: string;
  url19?: string;
  url20?: string;
  company_id?: string;
  mileageLow?: number;
  mileageHigh?: number;
  lowValue?: number;
  highValue?: number;
}
